/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { useState } from 'react'
import { useServiceContext } from '../../../../root'
import { useModal } from '../../../../contexts/ModalContext'
import Modal from '../../../../components/Modal'
import type { EosRolesErrorProps, EosConfig, EosOptions } from '../../../../types/eos'
import EosSetUpStep1Modal from './EosSetUpStep1Modal'

const EosStep1RolesError: React.FC<EosRolesErrorProps> = ({ variables, config, options }) => {
  const context = useServiceContext()
  const { translate } = context.service.filter
  const { showModal } = useModal()
  const [isOpen, setIsOpen] = useState(true)

  // The translation string uses "\n- " as a delimiter between the main message
  // and the two building-block requirement bullet points.
  const rolesErrorMessageData = translate('EOS_ROLES_ERROR_MESSAGE_TEXT').split('\n- ')

  const goBack = () => {
    showModal(<EosSetUpStep1Modal params={{ config, options }} />)
    doClose()
  }

  const doClose = () => {
    setIsOpen(false)
  }

  return (
    <Modal
      show={isOpen}
      handleClose={doClose}
      title={translate('NOTIFICATION_TYPE_EOS')}
      size="md"
      className="eos-roles-error-modal"
    >
      <Modal.Body>
        <div className="roles-error-text">
          {rolesErrorMessageData[0]}
          <ul className="roles-error-details">
            {rolesErrorMessageData.slice(1).map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
        <br />
        <div>
          <div>
            <b>{translate('CDS_TITLE')}: </b>
            <span>{variables.cdName}</span>
          </div>
          {!!variables.roles.length && (
            <div>
              <b>{translate('CONFLICTING_ROLES')}: </b>
              <span>{variables.roles.join(', ')}</span>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Button variant="link" onClick={doClose}>
          {translate('CANCEL')}
        </Modal.Footer.Button>
        <Modal.Footer.Button variant="secondary" onClick={goBack}>
          {translate('SEARCH_BACK')}
        </Modal.Footer.Button>
      </Modal.Footer>
    </Modal>
  )
}

export default EosStep1RolesError
